module.exports = __webpack_public_path__ + "img/Rectangle 7.661e1645.svg";